export default __webpack_public_path__ + "d4b626bca8df61bc7bebae891e31a7af.webp";